import React from 'react'
import DesktopLink from './DesktopLink'
import { linksPropTypes } from '../propTypes'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'

const DesktopMenu = ({ links }) => (
  <nav className='hidden xl:flex xl:items-center xl:gap-10'>
    {links.map(({ href, label }, index) => (
      <>
        {index === links.length - 1 && <LanguageSwitcher />}
        <DesktopLink
          href={href}
          label={label}
        />
      </>
    ))}
  </nav>
)

export default DesktopMenu

DesktopMenu.propTypes = linksPropTypes

DesktopMenu.defaultProps = {
  links: []
}
